import { defineMessages } from 'react-intl';

export const sidebarMessages = defineMessages({
  ANALYSIS: {
    id: 'sidebar.analysis',
    defaultMessage: 'Analysis',
    description: 'The label of the analysis icon on hover',
  },
  STATEMENTS: {
    id: 'sidebar.statements',
    defaultMessage: 'Statements',
    description: 'The label of the statements icon on hover',
  },
  DOCUMENTS: {
    id: 'sidebar.documents',
    defaultMessage: 'Documents',
    description: 'The label of the documents icon on hover',
  },
  FINANCIALDATA: {
    id: 'sidebar.financial_data',
    defaultMessage: 'Tax Data',
    description: 'The label of the financial data icon on hover',
  },
  DECISION: {
    id: 'sidebar.decision',
    defaultMessage: 'Loan decision',
    description: 'The label of the loan decision icon on hover',
  },
  IDENTITY: {
    id: 'sidebar.identity',
    defaultMessage: 'Identity & Compliance',
    description: 'The label of the identity icon on hover',
  },
  HOME: {
    id: 'sidebar.home',
    defaultMessage: 'Application list',
    description: 'The label of the home icon on hover',
  },
  ACTIVITY: {
    id: 'sidebar.activity',
    defaultMessage: 'Activity',
    description: 'The label of the activity icon on hover',
  },
  SETTINGS: {
    id: 'sidebar.settings',
    defaultMessage: 'Settings',
    description: 'The label of the settings icon on hover',
  },
  LOGIN: {
    id: 'login.form.connexion',
    defaultMessage: 'Log in',
    description: 'The title of log in tab',
  },
});
